/* eslint-disable @typescript-eslint/no-explicit-any */
// import Select, { createFilter } from "react-select";
import { Autocomplete, FormControl, TextField } from "@mui/material";
import { useState } from "react";
import { ListModel } from "../../../app/models/list-model";
import "./autocomplete-select.scss";

/* eslint-disable-next-line */
export interface AutocompleteSelectProps {
  //react-hook-form props
  // field: any;
  register?: any;
  getFieldState?: any;
  formState?: any;
  errors?: any;
  //select props
  name: string;
  label?: string;
  placeholder?: string;
  isMultiple: boolean;
  options: Array<ListModel>;
  required?: boolean;
  selectRef?: any;
  isClearable?: boolean;
  disabled?: boolean;
  hideSelectedValues?: boolean;
  handleChangeOption?: any;
  handleCreate?: (value: string) => void;
  showAssistiveTextAlways?: boolean;
  onChange: (value: string) => void;
  helperText?: string;
  value?: string;
}

export function AutocompleteSelect(props: AutocompleteSelectProps) {
  const [internalValue, setInternalValue] = useState<string>("");

  // Helper to get the selected option object from value
  const getSelectedOption = (val: string | undefined) =>
    props.options.find((opt) => String(opt.value) === String(val)) || null;

  // Use controlled value if provided, else internal state
  const selectedOption =
    typeof props.value !== "undefined"
      ? getSelectedOption(props.value)
      : getSelectedOption(internalValue);

  return (
    <div className="autocomplete-select-container">
      {props.options && props.register && (
        <FormControl required={props.required} fullWidth>
          <Autocomplete
            {...props.register(props.name)}
            value={selectedOption}
            disablePortal
            options={props.options}
            getOptionLabel={(option: ListModel) => option.label}
            isOptionEqualToValue={(option, value) => {
              const o = option as ListModel;
              const v = value as ListModel;
              return String(o.value) === String(v.value);
            }}
            renderInput={(params) => (
              <TextField {...params} label={props.label} />
            )}
            disabled={props.disabled}
            id={props.name}
            onChange={(event, newInputValue: ListModel | null) => {
              props.onChange(newInputValue?.value ? String(newInputValue.value) : "");
              if (typeof props.value === "undefined")
                setInternalValue(newInputValue?.value ? String(newInputValue.value) : "");
            }}
            onInputChange={(event: any, newValue: string | null) => {
              if (
                newValue !== null &&
                newValue.length > 3 &&
                props.handleCreate
              )
                props.handleCreate(newValue);
            }}
          />
          {props.helperText && (
            <p className="assistive-text">{props.helperText}</p>
          )}
          {props.errors && props.errors[props.name] && (
            <p className="error">
              {props.errors[props.name]?.message?.toString()}
            </p>
          )}
        </FormControl>
      )}

      {props.options && !props.register && (
        <FormControl required={props.required} fullWidth>
          <Autocomplete
            value={selectedOption}
            disablePortal
            options={props.options}
            getOptionLabel={(option: ListModel) => option.label}
            isOptionEqualToValue={(option, value) => {
              const o = option as ListModel;
              const v = value as ListModel;
              return String(o.value) === String(v.value);
            }}
            renderInput={(params) => (
              <TextField {...params} label={props.label} />
            )}
            disabled={props.disabled}
            id={props.name}
            onChange={(event, newInputValue: ListModel | null) => {
              props.onChange(newInputValue?.value ? String(newInputValue.value) : "");
              if (typeof props.value === "undefined")
                setInternalValue(newInputValue?.value ? String(newInputValue.value) : "");
            }}
            onInputChange={(event: any, newValue: string | null) => {
              if (
                newValue !== null &&
                newValue.length > 3 &&
                props.handleCreate
              )
                props.handleCreate(newValue);
            }}
          />
          {props.helperText && (
            <p className="assistive-text">{props.helperText}</p>
          )}
          {props.errors && props.errors[props.name] && (
            <p className="error">
              {props.errors[props.name]?.message?.toString()}
            </p>
          )}
        </FormControl>
      )}
    </div>
  );
}

export default AutocompleteSelect;
